export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const PL_UPGRADE_HEADER = 'product-library-upgrade';
export const PRICE_SCHEME_HEADER = 'price-scheme-id';

export enum Status {
  SUCCESS = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  INTERNAL_SERVER_ERROR = 500,
}
